import { Stack } from '@mui/material'
import type { FC } from 'react'
import { Length } from './Length'
import { StartPosition } from './StartPosition'

export const BarcodeRangeForm: FC = () => {
  return (
    <Stack spacing={3}>
      <StartPosition />
      <Length />
    </Stack>
  )
}
